import styled from "styled-components";

const ItemsPageStyled = styled.div`

`;

export default ItemsPageStyled;